import React from 'react';
import { autobind } from 'core-decorators';
import EditDialog from '../../../componentes/edit/edit-dialog';
import { Schema } from '../../../utils/form';
import { Row, Col } from 'src/componentes/grid';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { capitalizeFirstLetter } from '../../../utils/string';
import InputNumber from '../../../componentes/input-number/index';
import CondicionanteLookup from '../../../lookups/condicionante';
import DatePicker from 'src/componentes/date-picker';
import Input from 'src/componentes/input';

let schema = Schema.object({
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  valor: Schema.string()
    .label(<FormattedMessage id="valor" />)
    .required(),
  condicionante: Schema.string()
    .label(<FormattedMessage id="condicionante" />)
    .required(),
  dataInicio: Schema.string()
    .label(<FormattedMessage id="dataInicio" />)
    .required(),
  dataTermino: Schema.string().label(<FormattedMessage id="dataTermino" />),
});

@autobind
class FormEdit extends React.Component {
  render() {
    let { model, intl, resources } = this.props;
    return (
      <div>
        <Row>
          <Col md={4}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
          <Col md={5}>
            <div style={{ marginBottom: 15 }}>
              <CondicionanteLookup
                model={{
                  label: capitalizeFirstLetter(resources.condicionante),
                  value: model.getModel('condicionante').value,
                  requestChange: model.getModel('condicionante').requestChange,
                  errors: model.getModel('condicionante').errors,
                }}
                clearable={false}
                required
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <div style={{ marginBottom: 15 }}>
              <DatePicker
                month
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'dataInicio' })
                  ),
                  value: model.getModel('dataInicio').value,
                  requestChange: model.getModel('dataInicio').requestChange,
                  errors: model.getModel('dataInicio').errors,
                }}
                required
              />
            </div>
          </Col>
          <Col md={3}>
            <div style={{ marginBottom: 15 }}>
              <DatePicker
                month
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'dataTermino' })
                  ),
                  value: model.getModel('dataTermino').value,
                  requestChange: model.getModel('dataTermino').requestChange,
                  errors: model.getModel('dataTermino').errors,
                }}
              />
            </div>
          </Col>
          <Col md={3}>
            <div style={{ marginBottom: 15 }}>
              <InputNumber
                required
                precision={4}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'valor' })
                  ),
                  value: model.getModel('valor').value,
                  requestChange: model.getModel('valor').requestChange,
                  errors: model.getModel('valor').errors,
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

class CondicionanteEdit extends React.Component {
  render() {
    let { resources } = this.props;

    return (
      <EditDialog
        url="/ColaboradorCondicionante"
        title={capitalizeFirstLetter(resources.condicionante)}
        formComponent={FormEdit}
        schema={schema}
        width="60%"
        height="40%"
        respeitarAltura
        maxHeight="90%"
        resources={resources}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(CondicionanteEdit));
